import { classNames } from '../lib/classNames';
import { IHeroIcon } from '../../main/types/types';

export type PillBadgeColor = `gray` | `red` | `orange` | `yellow` | `green` | `blue` | `paidniceGreen`;

const colors: Record<PillBadgeColor, { fill: string; border: string }> = {
  gray: { fill: `bg-gray-100 text-gray-700`, border: `border-gray-200` },
  red: { fill: `bg-red-50 text-red-700`, border: `border-red-200` },
  orange: { fill: `bg-orange-50 text-orange-700`, border: `border-orange-200` },
  yellow: { fill: `bg-yellow-50 text-yellow-700`, border: `border-yellow-200` },
  green: { fill: `bg-green-50 text-green-700`, border: `border-green-200` },
  blue: { fill: `bg-blue-50 text-blue-700`, border: `border-blue-200` },
  paidniceGreen: { fill: `bg-paidniceGreen-50 text-paidniceGreen-700`, border: `border-paidniceGreen-200` },
};

const sizes = {
  /** Instalment tiles */
  xs: `px-[0.4375rem] py-px text-[0.6875rem]`,
  /** Page header and cards */
  sm: `px-2 py-0.5 text-xs`,
};

interface PillBadgeProps {
  children: React.ReactNode;
  color?: PillBadgeColor;
  size?: keyof typeof sizes;
  /** Adds a 1px border in the matching colour */
  bordered?: boolean;
  /** `tag` is the squarer label used for contact groups */
  shape?: `pill` | `tag`;
  icon?: IHeroIcon;
  className?: string;
}

/** Badge styles from the invoice page designs (6b/7b) */
export function PillBadge({
  children,
  color = `gray`,
  size = `sm`,
  bordered,
  shape = `pill`,
  icon: Icon,
  className,
}: PillBadgeProps) {
  return (
    <span className={ classNames(
      `inline-flex items-center gap-1 whitespace-nowrap font-medium`,
      colors[color].fill,
      bordered ? `border ${colors[color].border}` : ``,
      shape === `pill` ? `rounded-full ${sizes[size]}` : `rounded px-1.5 py-px text-[0.6875rem]`,
      className,
    ) }>
      { Icon ? <Icon className={ `h-3 w-3 shrink-0` } /> : null }
      { children }
    </span>
  );
}
